export enum ShopSelectShopTypeNumeric {
  AtHouse = 1,
  Family = 2,
  Cosmetic = 3,
  Pharmacy = 4,
  Wholesale = 5,
  Extra = 6,
  Master = 7,
  V1 = 8,
  MyPrice = 9,
}

export enum ShopSelectShopType {
  AtHouse = "MM",
  Family = "GM",
  Cosmetic = "DG",
  Pharmacy = "MA",
  Wholesale = "MO",
  Extra = "ME",
  Master = "MT",
  V1 = "V1",
  MyPrice = "MC",
}

export enum ShopSelectDisplayField {
  StoreType,
  Address,
  Schedule,
}
